<template>
  <label class="WCheckbox" :class="{ border, checked, disabled }" :for="name">
    <slot name="left" />

    <CheckboxRoot
      :checked="checked"
      @update:checked="
        (v: boolean) => {
          // supports multiple emit strategies
          $emit('update:checked', v);
          $emit('check', v);
          $emit('change', v);
        }
      "
      :disabled="disabled"
      class="CheckboxRoot"
      :style="{ width: width ? width : '1rem' }"
    >
      <CheckboxIndicator class="CheckboxIndicator" />
    </CheckboxRoot>
    <slot>
      <span v-if="label" class="">{{ label }}</span>
    </slot>

    <slot name="right" />
  </label>
</template>

<script lang="ts">
  import { CheckboxIndicator, CheckboxRoot } from 'radix-vue';

  export default {
    name: 'WCheckbox',
    emits: ['change', 'check', 'update:checked'],
    components: { CheckboxRoot, CheckboxIndicator },
    props: {
      checked: Boolean,
      disabled: Boolean,
      border: Boolean,
      label: String,
      name: String,
      width: String,
    },
  };
</script>

<style lang="scss">
  @import '@/assets/styles/variables.scss';

  .WCheckbox {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;

    .CheckboxRoot {
      // width: 1rem;
      aspect-ratio: 1;
      background-color: $white;
      border-radius: 0.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $input-placeholder;
      cursor: pointer;
    }
    .CheckboxRoot:hover {
      background-color: $neutral-gray-10;
    }

    .CheckboxRoot:focus {
      outline: none;
      background-color: $neutral-gray-10;
    }

    &.checked .CheckboxRoot {
      border-color: $primary-main;
      background-color: $primary-main;
    }

    .CheckboxIndicator {
      height: 65%;
      width: 70%;
      background-image: url('data:image/svg+xml,<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6.21739L5.28571 11L13 1" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>');
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }

    &.border {
      background-color: white;
      border-radius: 8px;
      border: 1px solid $bg-dark;
      padding: 16px 18px;
      &.checked {
        background-color: $primary-lighter;
        border: 1px solid $primary-main;
      }
    }

    &.disabled {
      color: $input-placeholder;
      * {
        cursor: not-allowed;
      }
      .CheckboxRoot {
        border-color: $input-border;
        background-color: $input-border;
      }
    }
  }
</style>
